import React from 'react'
import LogoPDF from "../../../../PDF.svg";
import { Link } from 'react-router'
import './orderbuy.css'
export default function OrderBuy(props) {

    return (
        <table className='OrderBuy'>
            <thead>
                <tr>
                    <td colSpan={3}>
                        Ordenes de Compra
                    </td>
                </tr>
                <tr>
                    <td>Tipo</td>
                    <td>Nombre</td>
                    <td>Archivo</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Orden de Compra</td>
                    <td>{props.name}</td>
                    <td>
                        <Link to={`/LinkOc/${props.hash}`} target="_blank" params={{ fromFeed: true }}>
                            <img src={LogoPDF} alt={`OrderBuyImg${props.id}`} />
                        </Link>
                    </td>
                </tr>
                <tr>
                    <td colSpan={3}>
                        {props.children}
                        
                    </td>
                </tr>
            </tbody>
        </table>

    )
}